import { AGENTS } from "./types"

const fetchAgents = data => ({
    type: AGENTS.FETCH_AGENTS,
    payload: data
})

const fetchAgentsSuccess = data => ({
    type: AGENTS.FETCH_AGENTS_SUCCESS,
    payload: data
})

export {
    fetchAgents,
    fetchAgentsSuccess
}